import { render, staticRenderFns } from "./WeChatNotificationSection.vue?vue&type=template&id=77bc2200&scoped=true&"
import script from "./WeChatNotificationSection.vue?vue&type=script&lang=js&"
export * from "./WeChatNotificationSection.vue?vue&type=script&lang=js&"
import style0 from "./WeChatNotificationSection.vue?vue&type=style&index=0&id=77bc2200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bc2200",
  null
  
)

export default component.exports